<template>
  <div class="scc_modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-content-donation-page">
        <div class="modal-body">
          <h5 class="" style="margin-bottom: 50px;">Appointment Confirmation</h5>
          <div class="info-block-blocked-section">
            <p class="p-blocked-section">{{ profileDonationDataPage.name }}</p>
            <p class="p-blocked-section">{{  profileDonationDataPage.address }}</p>
          </div>
          <div class="info-block-blocked-section">
            <p class="p-blocked-section"><span class="ph-blocked-section">Appointment Date:</span>{{ ' ' + profileDonationDataPage.date }}</p>
            <p class="p-blocked-section"><span class="ph-blocked-section">Appointment Time:</span>{{ ' ' + timeAppointmentPage }}</p>
          </div>
          <div class="info-block-blocked-section">
            <label class="label-form-css label-confirm-form-donation-page" v-if="smsEnable">Please send me text reminders
              <input
                  type="checkbox"
                  name="notify"
                  ref="confirmationCheck"
                  v-model.trim="checkConfirmation"/>
            </label>
            <div class="row" style="align-items: baseline;">
              <label class="label-form-css col-sm-auto">Cell:</label>
              <input
                  type="text"
                  class="form-control input-form-css col-sm"
                  v-model.trim="phoneMobileDonor"
                  :disabled="changeCell"
              >
              <font-awesome-icon class="svg-icon" :icon="['fas', 'pencil-alt']" @click="changeCellMethod"/>
            </div>
          </div>
          <div class="container-input-form row container-input-form-right col-sm .container-button-confirm-right">
            <button
                class="button-section btn button-confirm"
                type="button"
                v-on:click="confirmationOk"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons'
import {mapState} from "vuex";
library.add( faPencilAlt )
export default {
  name: "confirmationWindow",
  props: [ 'profileDonationData', 'timeAppointment' ],
  data(){
    return{
      profileDonationDataPage: null,
      timeAppointmentPage: null,
      changeCell: true,
      phoneMobileDonor: null,
      phoneMobileDonorOld: null,
      checkConfirmation: true,
      checkConfirmationOld: true,
    }
  },
  computed : {
    ...mapState({
      donorInformation: state => state.donorInformation,
      smsEnable: state => state.settingsAndCustomize.crmSettings.sendSms.smsEnable,
    })
  },
  created() {
    this.profileDonationDataPage = this.profileDonationData
    this.timeAppointmentPage = this.timeAppointment
    this.phoneMobileDonor = this.phoneMobileDonorOld = this.donorInformation.mobilePhone

    if (this.donorInformation.smsOptedOut !== ''
        && typeof this.donorInformation.smsOptedOut === 'boolean'
    ){
      this.checkConfirmation = this.checkConfirmationOld = !this.donorInformation.smsOptedOut
    }
  },
  methods: {
    confirmationOk() {
      if(this.checkConfirmation !== this.checkConfirmationOld){
        this.$store.commit('donorInformation/set_smsOptedOut', !this.checkConfirmation)
      }
      if(this.phoneMobileDonor !== this.phoneMobileDonorOld){
        this.$store.commit('donorInformation/set_phoneMobile', this.phoneMobileDonor)
      }

      this.$emit('afterConfirmation');
    },
    changeCellMethod() {
      this.changeCell = false
    },
  }
}
</script>

<style scoped>
  .svg-icon {
    width: 35px;
    height: auto;
  }
  .button-confirm {
    width: 70px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: auto;
  }
</style>
